export class QbExtractorModel {
    public ID: string;
    public CompanyID: string;
    public AccountingType: string; //QBOnline, QBDesktop, None
    public AccountingName: string; //QB Online Setup, QB Desktop Setup, No Setup (Please configure for setup)
    public HasUrl: boolean;
    public UrlContent: string;
    public DisplayContent: string;    
    public LastExtractStatus: string;
    public LastExtractDateTime: string;
    public constructor() {
        this.ID = "";
        this.CompanyID = "";
        this.AccountingName = "";
        this.AccountingType = "";
        this.HasUrl = true;
        this.UrlContent = "";
        this.DisplayContent = "";
    }
}